import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-pause",
  "use": "icon-th-pause-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-pause\">\n<path d=\"M25 4H20C19.4696 4 18.9609 4.21071 18.5858 4.58579C18.2107 4.96086 18 5.46957 18 6V26C18 26.5304 18.2107 27.0391 18.5858 27.4142C18.9609 27.7893 19.4696 28 20 28H25C25.5304 28 26.0391 27.7893 26.4142 27.4142C26.7893 27.0391 27 26.5304 27 26V6C27 5.46957 26.7893 4.96086 26.4142 4.58579C26.0391 4.21071 25.5304 4 25 4ZM25 26H20V6H25V26ZM12 4H7C6.46957 4 5.96086 4.21071 5.58579 4.58579C5.21071 4.96086 5 5.46957 5 6V26C5 26.5304 5.21071 27.0391 5.58579 27.4142C5.96086 27.7893 6.46957 28 7 28H12C12.5304 28 13.0391 27.7893 13.4142 27.4142C13.7893 27.0391 14 26.5304 14 26V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4ZM12 26H7V6H12V26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-pause.svg
// module id = YB4R
// module chunks = 84